// ConfigAccessButton.js

const getPermissionValue = (permissionKey, subTabKey = null, buttonCategory = null, buttonKey = null) => {
  try {
    const loggedData = JSON.parse(localStorage.getItem("logged_data"));
    const userPermissions = loggedData?.data?.permissions || {};
    
    // Handle different permission types
    if (buttonCategory && buttonKey) {
      const permission = userPermissions[permissionKey];
      if (permission && permission.allowed === true && permission.sub_tabs) {
        const fullKey = `${buttonCategory}_${buttonKey}`;
        return permission.sub_tabs[fullKey] === true;
      }
      return false;
    } else if (subTabKey) {
      const permission = userPermissions[permissionKey];
      if (permission && permission.allowed === true && permission.sub_tabs) {
        return permission.sub_tabs[subTabKey] === true;
      }
      return false;
    } else {
      const permission = userPermissions[permissionKey];
      return permission && permission.allowed === true;
    }
  } catch (error) {
    console.error("Error reading permissions from localStorage:", error);
    return false;
  }
  // return true; // For testing purposes, return true for all permissions
};

// Define the complete button configuration structure
const BUTTON_CONFIGS = {
  "App Order": {
    "Placed Button": {
      advanced_export: getPermissionValue("appOrders", null, "Placed Button", "advanced_export"),
      update_status: getPermissionValue("appOrders", null, "Placed Button", "update_status"),
      update_payment: getPermissionValue("appOrders", null, "Placed Button", "update_payment"),
      send_email: getPermissionValue("appOrders", null, "Placed Button", "send_email")
    },
    "Confirmed Button": {
      update_status: getPermissionValue("appOrders", null, "Confirmed Button", "update_status"),
      update_payment: getPermissionValue("appOrders", null, "Confirmed Button", "update_payment"),
      // issend_email: getPermissionValue("appOrders", null, "Confirmed Button", "issend_email"),
      // confirmed_Button: getPermissionValue("appOrders", null, "Confirmed Button", "confirmed_Button"),
      advanced_export: getPermissionValue("appOrders", null, "Confirmed Button", "advanced_export"),
      send_email: getPermissionValue("appOrders", null, "Confirmed Button", "send_email")
    },
    "Processing Button": {
      advanced_export: getPermissionValue("appOrders", null, "Processing Button", "advanced_export"),
      update_status: getPermissionValue("appOrders", null, "Processing Button", "update_status"),
      update_payment: getPermissionValue("appOrders", null, "Processing Button", "update_payment"),
      send_email: getPermissionValue("appOrders", null, "Processing Button", "send_email")
    },
    "Dispatch Button": {
      advanced_export: getPermissionValue("appOrders", null, "Dispatch Button", "advanced_export"),
      update_status: getPermissionValue("appOrders", null, "Dispatch Button", "update_status"),
      update_payment: getPermissionValue("appOrders", null, "Dispatch Button", "update_payment"),
      send_email: getPermissionValue("appOrders", null, "Dispatch Button", "send_email"),
      view_invoice: getPermissionValue("appOrders", null, "Dispatch Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("appOrders", null, "Dispatch Button", "view_delivery_challan")
    },
    "Delivered Button": {
      advanced_export: getPermissionValue("appOrders", null, "Delivered Button", "advanced_export"),
      update_status: getPermissionValue("appOrders", null, "Delivered Button", "update_status"),
      update_payment: getPermissionValue("appOrders", null, "Delivered Button", "update_payment"),
      send_email: getPermissionValue("appOrders", null, "Delivered Button", "send_email"),
      view_invoice: getPermissionValue("appOrders", null, "Delivered Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("appOrders", null, "Delivered Button", "view_delivery_challan")
    },
    "Cancelled Button": {
      advanced_export: getPermissionValue("appOrders", null, "Cancelled Button", "advanced_export"),
      update_status: getPermissionValue("appOrders", null, "Cancelled Button", "update_status"),
      update_payment: getPermissionValue("appOrders", null, "Cancelled Button", "update_payment"),
      send_email: getPermissionValue("appOrders", null, "Cancelled Button", "send_email"),
      view_invoice: getPermissionValue("appOrders", null, "Cancelled Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("appOrders", null, "Cancelled Button", "view_delivery_challan")
    },
    "Returned Button": {
      advanced_export: getPermissionValue("appOrders", null, "Returned Button", "advanced_export"),
      update_status: getPermissionValue("appOrders", null, "Returned Button", "update_status"),
      update_payment: getPermissionValue("appOrders", null, "Returned Button", "update_payment"),
      send_email: getPermissionValue("appOrders", null, "Returned Button", "send_email"),
      view_invoice: getPermissionValue("appOrders", null, "Returned Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("appOrders", null, "Returned Button", "view_delivery_challan")
    }
  },
  "Agronomist": {
    "Pending Button": {
      update_status: getPermissionValue("talkToAgronomist", null, "Pending Button", "update_status")
    },
    "Connected Button": {
      update_status: getPermissionValue("talkToAgronomist", null, "Connected Button", "update_status")
    }
  },
  "Bulk Order": {
    "Placed Button": {
      advanced_export: getPermissionValue("bulkOrders", null, "Placed Button", "advanced_export"),
      update_status: getPermissionValue("bulkOrders", null, "Placed Button", "update_status"),
      update_payment: getPermissionValue("bulkOrders", null, "Placed Button", "update_payment"),
      send_email: getPermissionValue("bulkOrders", null, "Placed Button", "send_email"),
      bulk_upload: getPermissionValue("bulkOrders", null, "Placed Button", "bulk_upload")
    },
    "Confirmed Button": {
      advanced_export: getPermissionValue("bulkOrders", null, "Confirmed Button", "advanced_export"),
      update_status: getPermissionValue("bulkOrders", null, "Confirmed Button", "update_status"),
      update_payment: getPermissionValue("bulkOrders", null, "Confirmed Button", "update_payment"),
      send_email: getPermissionValue("bulkOrders", null, "Confirmed Button", "send_email"),
      bulk_upload: getPermissionValue("bulkOrders", null, "Confirmed Button", "bulk_upload")
    },
    "Processing Button": {
      advanced_export: getPermissionValue("bulkOrders", null, "Processing Button", "advanced_export"),
      update_status: getPermissionValue("bulkOrders", null, "Processing Button", "update_status"),
      update_payment: getPermissionValue("bulkOrders", null, "Processing Button", "update_payment"),
      send_email: getPermissionValue("bulkOrders", null, "Processing Button", "send_email"),
      bulk_upload: getPermissionValue("bulkOrders", null, "Processing Button", "bulk_upload")
    },
    "Dispatch Button": {
      advanced_export: getPermissionValue("bulkOrders", null, "Dispatch Button", "advanced_export"),
      update_status: getPermissionValue("bulkOrders", null, "Dispatch Button", "update_status"),
      update_payment: getPermissionValue("bulkOrders", null, "Dispatch Button", "update_payment"),
      send_email: getPermissionValue("bulkOrders", null, "Dispatch Button", "send_email"),
      view_invoice: getPermissionValue("bulkOrders", null, "Dispatch Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("bulkOrders", null, "Dispatch Button", "view_delivery_challan"),
      bulk_upload: getPermissionValue("bulkOrders", null, "Dispatch Button", "bulk_upload")
    },
    "Delivered Button": {
      advanced_export: getPermissionValue("bulkOrders", null, "Delivered Button", "advanced_export"),
      update_status: getPermissionValue("bulkOrders", null, "Delivered Button", "update_status"),
      update_payment: getPermissionValue("bulkOrders", null, "Delivered Button", "update_payment"),
      send_email: getPermissionValue("bulkOrders", null, "Delivered Button", "send_email"),
      view_invoice: getPermissionValue("bulkOrders", null, "Delivered Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("bulkOrders", null, "Delivered Button", "view_delivery_challan"),
      bulk_upload: getPermissionValue("bulkOrders", null, "Delivered Button", "bulk_upload")
    },
    "Cancelled Button": {
      advanced_export: getPermissionValue("bulkOrders", null, "Cancelled Button", "advanced_export"),
      update_status: getPermissionValue("bulkOrders", null, "Cancelled Button", "update_status"),
      update_payment: getPermissionValue("bulkOrders", null, "Cancelled Button", "update_payment"),
      send_email: getPermissionValue("bulkOrders", null, "Cancelled Button", "send_email"),
      view_invoice: getPermissionValue("bulkOrders", null, "Cancelled Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("bulkOrders", null, "Cancelled Button", "view_delivery_challan"),
      bulk_upload: getPermissionValue("bulkOrders", null, "Cancelled Button", "bulk_upload")
    },
    "Returned Button": {
      advanced_export: getPermissionValue("bulkOrders", null, "Returned Button", "advanced_export"),
      update_status: getPermissionValue("bulkOrders", null, "Returned Button", "update_status"),
      update_payment: getPermissionValue("bulkOrders", null, "Returned Button", "update_payment"),
      send_email: getPermissionValue("bulkOrders", null, "Returned Button", "send_email"),
      view_invoice: getPermissionValue("bulkOrders", null, "Returned Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("bulkOrders", null, "Returned Button", "view_delivery_challan"),
      bulk_upload: getPermissionValue("bulkOrders", null, "Returned Button", "bulk_upload"),
      view: getPermissionValue("bulkOrders", null, "Returned Button", "view"),
      download: getPermissionValue("bulkOrders", null, "Returned Button", "download")
    }
  },
  "Return & Cancel Request": {
    "cancel request button": {
      accepted: getPermissionValue("returnCancelRequest", null, "cancel request button", "accepted"),
      rejected: getPermissionValue("returnCancelRequest", null, "cancel request button", "rejected")
    },
    "return request button": {
      accepted: getPermissionValue("returnCancelRequest", null, "return request button", "accepted"),
      rejected: getPermissionValue("returnCancelRequest", null, "return request button", "rejected")
    }
  },
  "Quotation/Proforma Invoice": {
    create_quotation_proforma: getPermissionValue("quotation", "create_quotation_proforma"),
    view_quotation_pdf: getPermissionValue("quotation", "view_quotation_pdf"),
    send_email: getPermissionValue("quotation", "send_email"),
    view_proforma_invoice: getPermissionValue("quotation", "view_proforma_invoice")
  },
  "Product Management": {
    add_product: getPermissionValue("agriStore", "add_product"),
    manage_companies_and_categories: getPermissionValue("agriStore", "manage_companies_and_categories"),
    manage_image: getPermissionValue("agriStore", "manage_image"),
    edit_product: getPermissionValue("agriStore", "edit_product"),
    delete_product: getPermissionValue("agriStore", "delete_product")
  },
  "Translation Management/Content": {
    add_translation: getPermissionValue("groceries", "add_translation"),
    edit: getPermissionValue("groceries", "edit"),
    delete: getPermissionValue("groceries", "delete")
  },
  "Post": {
    delete: getPermissionValue("farmerForum", "delete"),
    view_likes: getPermissionValue("farmerForum", "view_likes"),
    comment: getPermissionValue("farmerForum", "comment")
  },
  "Knowledge hub": {
    manage_categories: getPermissionValue("successStories", "manage_categories"),
    add_course: getPermissionValue("successStories", "add_course"),
    edit: getPermissionValue("successStories", "edit"),
    delete: getPermissionValue("successStories", "delete"),
    open: getPermissionValue("successStories", "open")
  },
  "Event Types": {
    create_event: getPermissionValue("eventType", "create_event"),
    update: getPermissionValue("eventType", "update"),
    edit: getPermissionValue("eventType", "edit"),
    delete: getPermissionValue("eventType", "delete")
  },
  "Crop types": {
    create_crop: getPermissionValue("cropType", "create_crop"),
    update: getPermissionValue("cropType", "update"),
    edit: getPermissionValue("cropType", "edit"),
    delete: getPermissionValue("cropType", "delete")
  },
  "Enquiry form": {
    enquiry_upload: getPermissionValue("enquiry", "enquiry_upload"),
    export_to_excel: getPermissionValue("enquiry", "export_to_excel")
  },
  "Field visit": {
    export_to_excel: getPermissionValue("fieldVisit", "export_to_excel"),
    view_image: getPermissionValue("fieldVisit", "view_image")
  },
  "Category": {
    add_category: getPermissionValue("category", "add_category"),
    edit: getPermissionValue("category", "edit"),
    delete: getPermissionValue("category", "delete")
  },
  "Crop hub": {
    add_crop: getPermissionValue("cropHub", "add_crop"),
    view: getPermissionValue("cropHub", "view"),
    edit: getPermissionValue("cropHub", "edit"),
    delete: getPermissionValue("cropHub", "delete")
  },
  "Disease Advisory": {
    "Categories Button": {
      add_category: getPermissionValue("diseaseAdvisory", null, "Categories Button", "add_category"),
      edit: getPermissionValue("diseaseAdvisory", null, "Categories Button", "edit"),
      delete: getPermissionValue("diseaseAdvisory", null, "Categories Button", "delete")
    },
    "Sub Categories Button": {
      add_category: getPermissionValue("diseaseAdvisory", null, "Sub Categories Button", "add_category"),
      edit: getPermissionValue("diseaseAdvisory", null, "Sub Categories Button", "edit"),
      delete: getPermissionValue("diseaseAdvisory", null, "Sub Categories Button", "delete")
    },
    "FAQs Button": {
      add_faqs: getPermissionValue("diseaseAdvisory", null, "FAQs Button", "add_faqs"),
      edit: getPermissionValue("diseaseAdvisory", null, "FAQs Button", "edit"),
      delete: getPermissionValue("diseaseAdvisory", null, "FAQs Button", "delete")
    }
  },
  "AI Chat bot": {
    add_questions: getPermissionValue("aiChatBot", "add_questions"),
    edit: getPermissionValue("aiChatBot", "edit"),
    delete: getPermissionValue("aiChatBot", "delete")
  },
  "Users": {
    add_user: getPermissionValue("users", "add_user"),
    edit: getPermissionValue("users", "edit"),
    delete: getPermissionValue("users", "delete")
  },
  "User Types & Permissions": {
    add_user_type: getPermissionValue("permissions", "add_user_type"),
    edit_permission: getPermissionValue("permissions", "edit_permission"),
    edit_user_type: getPermissionValue("permissions", "edit_user_type"),
    delete_user_type: getPermissionValue("permissions", "delete_user_type")
  },
  "FAQ": {
    faq_upload: getPermissionValue("FAQs", "faq_upload"),
    add_faq: getPermissionValue("FAQs", "add_faq"),
    edit_faq: getPermissionValue("FAQs", "edit_faq"),
    delete_faq: getPermissionValue("FAQs", "delete_faq")
  }
};

// Export the config directly as a regular object (not a proxy)
const buttonConfig = BUTTON_CONFIGS;

export default buttonConfig;